export const isDashboardDark = (theme) =>
  theme?.palette?.type === "dark" ||
  theme?.palette?.mode === "dark" ||
  theme?.mode === "dark";

export const dashboardColors = (isDark) => ({
  text: isDark ? "#ffffff" : "#0f172a",
  textMuted: isDark ? "#e2e8f0" : "#334155",
  textSoft: isDark ? "#cbd5e1" : "#64748b",
});
